import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import throttle from "lodash/throttle";
import * as api from "../api/Api";
import { loadState, saveState, clearState } from "../localStorage";

const persistedState = loadState();
if (persistedState) {
  if (persistedState.auth) {
    if (persistedState.auth.api_token) {
      api.setConfigWithBearerTokenToken(persistedState.auth.api_token);
    }
  }
}
const middlewares = [thunk.withExtraArgument(api)];
const store = createStore(
  rootReducer,
  persistedState,
  applyMiddleware(...middlewares)
);

store.subscribe(
  throttle(() => {
    if (store.getState().auth && store.getState().auth.clear_local_storage) {
      clearState();
      return;
    }
    saveState({
      state: {
        candidate: store.getState().candidate,
        auth: store.getState().auth,
        lang: {
          current_lang: store.getState().lang["current_lang"],
          candidate_pref_lang: store.getState().lang["candidate_pref_lang"],
          candidate_profile_lang: store.getState().lang["candidate_profile_lang"],
        },
        assesment: store.getState().assesment,
        assesmentTest: {
          id: store.getState().assesmentTest["id"],
          elapsed_time: store.getState().assesmentTest["elapsed_time"],
        },
      },
    });
  }, 1000)
);

// if(process.env.NODE_ENV === 'development'){
//   store.subscribe(() => {
//     console.log(store.getState())
//   })
// }

export default store;
